<template>
<v-app>
    <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" md="4" sm="12">
      <v-select v-model="selected_item" :items="items" prepend-icon="mdi-notebook-edit" label="Select topic"></v-select>
      </v-col>
        <input type="file"  @change="upload($event)"  accept=".bin" id="file-input">   
      </v-row>
      <br><br>
      <v-row>
      <v-btn rounded color="primary"  dark @click="send_data()">
      {{this.btn_msg}}
      </v-btn>
      </v-row>
      </v-container>
      </v-app>
</template>
<script>
// import constants from "../constants";
import axios from 'axios';
export default {
    name:'DataToDB',
     data: () => ({
      // items: ['350424061330773/data', '350424061327738/data', '350424066367846/data', '350424066263748/data'],
      items:[],
      selected_item:'',
      event_var:'',
      file_data:null,
      btn_msg:'Upload Data',
      
    }),
    mounted(){
      console.log("excuting mounted method")
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/get_topic`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        }}
       axios(config)
        .then((response) => {
        console.log("priniting response",response.data)
        this.items = response.data.data
        })
        
    },

    methods:{
    upload(event){
     this.event_var=event
     this.file_data=1
  },
  send_data(){
            if (this.selected_item=='' || this.file_data==null) {
            alert("Select a topic and choose corresponding file to the selected topic.")
           }else{
            this.btn_msg='PLEASE WAIT DATA INSERTING TO DATABASE...'
            let event_obj=this.event_var
            let data = new FormData();
            let file = event_obj.target.files[0];
            let params='';
            data.append('name', 'my-file')
            data.append('file', file)
            params = `?_t=${this.selected_item}`;
           
            let config = {
                       header : {'Content-Type' : 'multipart/form-data'}
                       }
            axios.post(`${this.$config.backend_url}/file-upload${params}`, data, config).then((response)=>
                {if(response.status==201)
                {this.btn_msg='Upload Data'
                alert("Records inserted successfully.") 
                }
                console.log("printing response ===>",response.status)
                })} }
  }
  
}
</script>
<style>
.center {
  align-items: center;
}
</style>